export class DischargeReportSave {
    VesselArrivalDateUTC; // UTC
    VesselDischargeCommencedDateUTC; // UTC
    VesselDischargeCompletedDateUTC; // UTC
    LivestockDischargedEdit; // array
    LivestockDischargedAddition; // array

    constructor(vesselArrivalDate, vesselDischargeCommencedDate, vesselDischargeCompletedDate, livestockDischargedEdit, livestockDischargedAddition) {
        this.VesselArrivalDateUTC = vesselArrivalDate;
        this.DischargeCommencedDateUTC = vesselDischargeCommencedDate;
        this.DischargeCompletedDateUTC = vesselDischargeCompletedDate;
        this.LivestockDischargedEdit = livestockDischargedEdit;
        this.LivestockDischargedAddition = livestockDischargedAddition;
    }
}

export class DischargeReportLivestockDischarged {
    ID;
    NumberDischarged;

    constructor(id, numberDischarged) {
        this.ID = id;
        this.NumberDischarged = numberDischarged;
    }
}


export class DischargeReportLivestockDischargedAddition {
    SpeciesID;
    ClassID;
    NumberDischarged;

    constructor(speciesID, classID, numberDischarged) {
        this.SpeciesID = speciesID;
        this.ClassID = classID;
        this.NumberDischarged = numberDischarged;
    }
}